import { Client } from "@/types/types";
import { addMonths, isBefore, format, isPast } from "date-fns";


// Re-export the imported types to maintain backward compatibility
// Use 'export type' when re-exporting types with isolatedModules enabled

export const getInitials = (firstName: string, lastName: string): string => {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`;
};

export const isSubscriptionExpiringSoon = (client: Client): boolean => {
  if(!client.expiryDate) return false;
  const expiryDate = new Date(client.expiryDate);
  
  // First check if the subscription is already expired
  if (isPast(expiryDate)) {
    return false;  // It's already expired, not "expiring soon"
  }
  
  // Then check if it will expire within a month
  const oneMonthFromNow = addMonths(new Date(), 1);
  return isBefore(expiryDate, oneMonthFromNow);
};

export const formatDate = (date: string | Date): string => {
  if (!date) return "";
  try {
    return format(new Date(date), 'dd/MM/yyyy');
  } catch (error) {
    console.error("Error formatting date:", date, error);
    return "";
  }
};

export const getStatusBadgeStyle = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'active':
      return "bg-emerald-500 hover:bg-emerald-600";
    case 'expired':
      return "bg-orange-500 hover:bg-orange-600";
    case 'blocked':
      return "bg-red-500 hover:bg-red-600";
    case 'paused':
      return "bg-amber-500 hover:bg-amber-600";
    default:
      return "";
  }
};

